import ContactDetailsFunctional from "../ContactsDetails/ContactDetailsFunctional";
import {
	Typography,
	Stack
} from '@mui/material';

import NewAddNewContactButton from "../AddNewContact/NewAddNewContactButton";
import { ImagePath } from "../../../assets/ImagePath";
import AddNewContactFunctional from "../AddNewContact/AddNewContactFunctional";
import ModalNewUI from "../../../components/ui/Modals/ModalMessages/ModalNewUI";
 
const ContactDetailsView = (props) => {
	let {
		contact,
		startConversation,
		selectedDomain,
		allProfileImages,
		balance,
		openRecharge,
		setAddContactMenu,
		addContactMenu
	} = props;


	contact = props.contact;
	if (!contact || Object.keys(contact).length <= 1) {
		return (
			<div className="Catalog-sidebar sidebar-sm" id="sidebar-collapse" style={{ flex: 1, backgroundColor: "#fff", marginLeft: "25px", marginTop: "12px", borderTopLeftRadius: "54px", borderBottomLeftRadius: "10px" }}>
				<div className="py-5">
					<Stack flexDirection='column' alignItems='center' justifyContent='center' sx={{ marginY: "8px", height: "80vh" }}>
						<img src={ImagePath.invite} style={{ width: "12rem" }} />
						<div style={{ marginTop: '15px' }}>
							<Typography variant="h6" style={{ fontSize: "14px", fontFamily: "Figtree-Regular", fontWeight: 600, color: "#15194B", textAlign: "center" }}>
								Connect with maritime professionals,
							</Typography>
							<Typography variant="h6" style={{ fontSize: "14px", fontFamily: "Figtree-Regular", fontWeight: 600, color: "#15194B", textAlign: "center" }}>
								colleagues & friends at sea and onshore.
							</Typography>
						</div>
						<Typography style={{ fontSize: "14px", fontFamily: "Figtree-Regular", fontWeight: 400, color: "#404585", textAlign: "center", marginTop: "1rem" }}>
							Extend your maritime circle
						</Typography>
						<NewAddNewContactButton {...props} />
					</Stack>
				</div>
			</div>
		);
	};


	let currentUserId = props.user.userId;
	return (
		<div
			className="Catalog-sidebar sidebar-sm"
			id="sidebar-collapse" style={{ flex: 1, backgroundColor: "#fff", marginLeft: "25px", marginTop: "25px", borderTopLeftRadius: "54px", borderBottomLeftRadius: "10px" }}
		>
			<div>
				<div
					className="py-5"
				>
					<ContactDetailsFunctional
						{...props}
						user={props.user}
						balance={balance}
						addContactMenu={addContactMenu}
						setAddContactMenu={setAddContactMenu}
						contact={contact}
						currentUserId={currentUserId}
						selectedDomain={selectedDomain}
						startConversation={startConversation}
						remove={props.remove}
						userId={props.userId}
						allProfileImages={allProfileImages}
						emailAddress={props.emailAddress}
						accept={props.accept}
						ignore={props.ignore}
						sendMsgForBanner={props.sendMsgForBanner}
						openRecharge={openRecharge}
						fetchContacts={(data) => {
							props.fetchContacts(data);
						}}
						selectedContactAction={props.selectedContactAction}
						updateSelectedContact={props.updateContactSelected}
					/>
					{addContactMenu && (
						<ModalNewUI
							onClose={() => setAddContactMenu(false)}
							headerContent={'Add new contact'}
							open={addContactMenu}
							customDialogStyles={{ width: '1050px', maxWidth: '1200px', height: '650px', maxHeight: '700px', overflowY: 'hidden' }}
						>
							<AddNewContactFunctional
								{...props}
								cancel={() => setAddContactMenu(false)}
								selectedTabFromParent="emailInvite"
								fetchContacts={(data) => {
									props.fetchContacts(data, true);
								}}
							/>
						</ModalNewUI>
					)}
				</div>
			</div>
		</div>
	);
};

export default ContactDetailsView;
